<template>
    <div id="payType">
        <Header title="支付方式" :show-back="true"></Header>
        <div class="typeWrap">
            <!--银行卡-->
            <div class="typeBox">
                <div class="typeList" @click.self="showBank = !showBank">
                    <div class="left">
                        <img src="../../assets/img/c2c/yl_active@3x.png" alt="" class="yl"/>
                        <span>绑定银行卡</span>
                    </div>
                    <div class="right">
                        <span>{{checked ? "显示" : "不显示"}}</span>
                        <van-switch v-model="checked" size="22px" @change="changeSwitch('bank')"
                                    active-color="#EEEEEE" inactive-color="#EEEEEE"/>
                    </div>
                </div>
                <bank v-if="showBank" :bankInfo="bankInfo"></bank>
            </div>
            <!--支付宝-->
            <div class="typeBox">
                <div class="typeList" @click.self="showAli = !showAli">
                    <div class="left">
                        <img src="../../assets/img/c2c/ali_active@3x.png" alt="" class="ali"/>
                        <span>绑定支付宝</span>
                    </div>
                    <div class="right">
                        <span>{{aliPayChecked ? "显示" : "不显示"}}</span>
                        <van-switch v-model="aliPayChecked" size="22px" @change="changeSwitch('alipay')"
                                    active-color="#EEEEEE" inactive-color="#EEEEEE"/>
                    </div>
                </div>
                <aliPay v-if="showAli" :aliInfo="aliInfo"></aliPay>
            </div>
            <!--微信-->
            <div class="typeBox">
                <div class="typeList" @click.self="showWx = !showWx">
                    <div class="left">
                        <img src="../../assets/img/c2c/wx_active@3x.png" alt="" class="wx"/>
                        <span>绑定微信支付</span>
                    </div>
                    <div class="right">
                        <span>{{wxPayChecked ? "显示" : "不显示"}}</span>
                        <van-switch v-model="wxPayChecked" size="22px" @change="changeSwitch('weixin')"
                                    active-color="#EEEEEE" inactive-color="#EEEEEE"/>
                    </div>
                </div>
                <wxPay v-if="showWx" :wxInfo="wxInfo"></wxPay>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from "../../components/header";
    import bank from "./components/bank"
    import aliPay from "./components/aliPay.vue"
    import wxPay from "./components/wxPay.vue"
    import {mapState} from "vuex"

    export default {
        name: "payType",
        components: {
            Header,
            bank,
            aliPay,
            wxPay,
        },
        data() {
            return {
                checked: false,
                aliPayChecked: false,
                wxPayChecked: false,
                // 信息
                bankInfo: null,
                aliInfo: null,
                wxInfo: null,
                // 展示列表
                showBank: false,
                showAli: false,
                showWx: false,
            }
        },
        created() {
            if (!this.userInfo.real_name) {
                this.$dialog.confirm({
                    message: '请先进行实名认证'
                }).then(() => {
                    this.$router.push({path: '/certification'});
                }).catch(() => {
                    this.$router.go(-1);
                });
            } else {
                this.getInfoData();
            }
        },
        computed: {
            ...mapState(['userInfo'])
        },
        methods: {
            getInfoData() {
                // 绑定支付方式页面信息
                this.ajax.post('appapi/c2c/paytype', {}).then((res) => {
                    if (res.data.code === 1) {
                        this.bankInfo = res.data.data.bank || {};
                        this.aliInfo = res.data.data.alipay || {};
                        this.wxInfo = res.data.data.weixin || {};
                        // 支付方式显示隐藏
                        this.checked = this.bankInfo.status === 1;
                        this.aliPayChecked = this.aliInfo.status === 1;
                        this.wxPayChecked = this.wxInfo.status === 1;
                    }
                })
            },
            changeSwitch(type) {
                this.ajax.post('appapi/c2c/show_hide_payment', {type: type}).then((res) => {
                    if (res.data.code === 1) {
                        this.$toast(res.data.msg);
                    } else {
                        switch (type) {
                            case "bank":
                                this.checked = !this.checked;
                                break;
                            case "alipay":
                                this.aliPayChecked = !this.aliPayChecked;
                                break;
                            case "weixin":
                                this.wxPayChecked = !this.wxPayChecked;
                                break;
                        }
                    }
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    #payType {
        .typeWrap {
            margin-top: 44px;
            padding: 0 33px;

            .typeBox {
                margin-top: 30px;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0 10px 18px 0 rgba(48, 77, 120, 0.06);
                border-radius: 20px;
            }

            .typeList {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 98px;
                padding: 0 34px 0 40px;

                .left {
                    display: flex;
                    align-items: center;

                    span {
                        font-size: 28px;
                        font-weight: bold;
                        color: rgba(51, 51, 51, 1);
                    }

                    .yl {
                        width: 44px;
                        height: 28px;
                        margin-right: 12px;
                    }

                    .ali {
                        width: 38px;
                        height: 38px;
                        margin-right: 15px;
                    }

                    .wx {
                        width: 41px;
                        height: 36px;
                        margin-right: 12px;
                    }
                }

                .right {
                    display: flex;
                    align-items: center;

                    span {
                        margin-right: 13px;
                        font-size: 24px;
                        font-weight: 500;
                        color: rgba(79, 86, 104, 1);
                    }

                    /deep/ .van-switch {
                        border: none;

                        /deep/ .van-switch__node {
                            background: #B3B3B3;
                            box-shadow: 0 3px 6px 0 rgba(179, 179, 179, 0.5);
                        }
                    }

                    /deep/ .van-switch--on {
                        /deep/ .van-switch__node {
                            background: #1FC26D;
                            box-shadow: 0 3px 6px 0 rgba(21, 195, 102, 0.5);
                        }
                    }
                }
            }
        }
    }
</style>
